<template>
  <div>
    <h1 class="page-title">Main Page</h1>

    <base-date-picker v-model="testDate" :label="'Date Value: ' + testDate"/>


    <base-input v-model="testVal" :label="'Test Value: ' + testVal"/>
  </div>
</template>

<script>
import BaseDatePicker from '@/components/BaseDatePicker';
import BaseInput from '@/components/BaseInput';

export default {
  name: 'Main',
  components: { BaseInput, BaseDatePicker },
  data() {
    return {
      testDate: null,
      testVal: 'hello',
    };
  },
};
</script>
